module.exports = __webpack_public_path__ + "img/低压配电.233cd33e.png";